<template>
    <div class="ReportsPane">
        <div class="container-fluid container-fill">
            <div class="row">
                <div class="col-md-4">
                    <h4>Intake Reports</h4>
                    <ReportDownloader report-label="MH Intake Paperwork Template"
                                      endpoint="Wraparound/Reports/ClientReports/GetMentalHealthIntakePaperworkTemplate"
                                      :parameter-schema="ParamsClientLanguage"
                                      report-description="Generates PDF document with prefilled info for MH intake forms.  PDF form can be downloaded for remaining info fill-in." />
                    <ReportDownloader report-label="MH Psych Referral Template"
                                      endpoint="Wraparound/Reports/ClientReports/GetMentalHealthPsychReferralTemplate"
                                      :parameter-schema="ParamsClientRelationships"
                                      report-description="Generates PDF document with prefilled info for MH Psych Referral.  PDF form can be downloaded for remaining info fill-in." >

                </div>
                <div class="col-md-4">
                    <h4>Monthly Reports</h4>
                    <ReportDownloader report-label="Wraparound Monthly Summary Template"
                                      endpoint="Wraparound/Reports/ClientReports/WrapMonthlySummaryReport"
                                      :parameter-schema="ParamsClientMonthYear"
                                      report-description="Generates a monthly Wraparound Services Summary to be downloaded and completed by the facilitator." />
                    <ReportDownloader report-label="MH Monthly Summary Template"
                                      endpoint="Wraparound/Reports/ClientReports/MentalHealthMonthlySummaryReport"
                                      :parameter-schema="ParamsClientMonthYear"
                                      report-description="Generates a monthly Mental Health Services Summary to be downloaded and completed by the clinician." />
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faList } from '@fortawesome/free-solid-svg-icons';
    library.add(faList);
    import { faChild } from '@fortawesome/free-solid-svg-icons';
    library.add(faChild);
    //import components
    import ReportDownloader from '../../../Core/UI/ReportDownloader.vue';
    export default {
        props: ["ChildRecordData"],
        data: function () {
            return {

                ParamsClientRelationships: [
                    {
                        Label: "Client:",
                        Name: "ClientSubProgramMembershipID",
                        Type: "HiddenConstant",
                        DisplayValue: "",
                        Value: ""
                    },
                    {
                        Label: "Guardian",
                        Name: "GuardianID",
                        Type: "Select",
                        Required: true,
                        Options: []
                    }
                ],
                ParamsClientMonthYear: [
                    {
                        Label: "Client:",
                        Name: "ClientSubProgramMembershipID",
                        Type: "HiddenConstant",
                        DisplayValue: "",
                        Value: ""
                    },
                    {
                        Label: "Month:",
                        Name: "Month",
                        Type: "Select",
                        Required: true,
                        Options: [
                            {
                                text: "January",
                                value: 1
                            },
                            {
                                text: "February",
                                value: 2
                            },
                            {
                                text: "March",
                                value: 3
                            },
                            {
                                text: "April",
                                value: 4
                            },
                            {
                                text: "May",
                                value: 5
                            },
                            {
                                text: "June",
                                value: 6
                            },
                            {
                                text: "July",
                                value: 7
                            },
                            {
                                text: "August",
                                value: 8
                            },
                            {
                                text: "September",
                                value: 9
                            },
                            {
                                text: "October",
                                value: 10
                            },
                            {
                                text: "November",
                                value: 11
                            },
                            {
                                text: "December",
                                value: 12
                            },
                        ]
                    },
                    {
                        Label: "Year:",
                        Name: "Year",
                        Type: "Select",
                        Required: true,
                        Options: [
                            {
                                text: "2020",
                                value: 2020
                            },
                            {
                                text: "2021",
                                value: 2021
                            },
                            {
                                text: "2022",
                                value: 2022
                            },
                            {
                                text: "2023",
                                value: 2023
                            },
                            {
                                text: "2024",
                                value: 2024
                            },
                            {
                                text: "2025",
                                value: 2025
                            },
                            {
                                text: "2026",
                                value: 2026
                            }
                        ]
                    }
                ],
                ParamsClientLanguage: [
                    {
                        Label: "Client:",
                        Name: "ClientSubProgramMembershipID",
                        Type: "HiddenConstant",
                        DisplayValue: "",
                        Value: ""
                    },
                    {
                        Label: "Language:",
                        Name: "Language",
                        Type: "Select",
                        Required: true,
                        Options: [
                            {
                                text: "English",
                                value: "English"
                            },
                            {
                                text: "Spanish",
                                value: "Spanish"
                            }
                        ]
                    },
                ],
                ParamsStartEnd: [
                    {
                        Label: "Start Date:",
                        Name: "StartDate",
                        Type: "Date",
                        Required: true
                    },
                    {
                        Label: "End Date:",
                        Name: "EndDate",
                        Type: "Date",
                        Required: true
                    }
                ],
            };
        },
        methods: {
            GetGaurdians() {
                this.$MasterAPI.ExecuteRequest("GET", "Core/Contacts/ClientFamily", { ClientSubProgramMembershipID: this.ChildRecordData.Id }, this.GetGaurdiansSuccess, () => { }, false);
            },
            GetGaurdiansSuccess(response) {
                this.ParamsClientRelationships[1].Options = response.data.data;
            }
        },
        computed: {
        },
        components: {
            ReportDownloader
        },
        mounted() {
            this.ParamsClientMonthYear[0].Value = this.ChildRecordData.Id
            this.ParamsClientMonthYear[0].DisplayValue = this.ChildRecordData.Client.Person.FullName;
            this.ParamsClientLanguage[0].Value = this.ChildRecordData.Id
            this.ParamsClientLanguage[0].DisplayValue = this.ChildRecordData.Client.Person.FullName;
            this.ParamsClientRelationships[0].Value = this.ChildRecordData.Id
            this.ParamsClientRelationships[0].DisplayValue = this.ChildRecordData.Client.Person.FullName;
            this.GetGaurdians();
        }
    }
</script>

<style scoped>
</style>